import { useCallback, useEffect, useState } from "react";
import { TupleType } from "typescript";

const useRequest = <T>(url: string, options: RequestInit, requestOnInit: boolean = false): [undefined|T, (bodyOrParams?: any) => Promise<T|undefined>] => {
  const [data, setData] = useState<T>();

  const doRequest = useCallback(
    async (bodyOrParams?: any) => {
      let authorizing = false;
      let validAuthorization = false;
      if (options.headers instanceof Array) {
        options.headers.forEach(x => {
          if (x[0] === 'authorization') {
            authorizing = true;
            validAuthorization = !!x[1];
          }
        });
      }

      if (authorizing && !validAuthorization) return;

      if (options.method !== 'GET') {
        if (options.headers instanceof Array) {
          if (!options.headers.find(x => x[0] === 'Accept' && x[1] === 'application/json')) {
            options.headers.push(['Accept', 'application/json'], ['Content-Type', 'application/json']);
          }
        }

        if (bodyOrParams) {
          let tmpBody = {};
          if (options.body) tmpBody = options.body;
          options.body = JSON.stringify({...JSON.parse(tmpBody as any), ...bodyOrParams});
        }
      }

      
      
      let result = await fetch(process.env.REACT_APP_API+url, {...options});
      let json = await result.json() as T;
      setData(json);
      return json;
    }, [url, options, setData]
  );
  useEffect(() => {
    if (requestOnInit) doRequest();
  }, []);

  return [
    data,
    doRequest,
  ]
};

export default <T>(url: string, args: RequestInit, requestOnInit: boolean = false) => useRequest<T>(url, {...args}, requestOnInit);